var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9671 20.6076C21.9638 20.6159 21.9604 20.6241 21.9568 20.6322C21.9386 20.6728 21.9151 20.7108 21.887 20.7451C21.7954 20.8571 21.656 20.9286 21.5 20.9286H6.31279C6.09957 20.9286 5.90981 20.7934 5.84019 20.5918L3.02741 12.449C2.91523 12.1242 3.15644 11.7857 3.50001 11.7857H18.6872C18.9004 11.7857 19.0902 11.9209 19.1598 12.1225L21 17.4497V5.5H15.7183L13.9231 7.5349C13.8282 7.64249 13.6917 7.70412 13.5482 7.70412H7.00001V10.9936C7.00001 11.2697 6.77615 11.4936 6.50001 11.4936C6.22386 11.4936 6.00001 11.2697 6.00001 10.9936V7.20412C6.00001 6.92798 6.22386 6.70412 6.50001 6.70412H13.3225L15.1177 4.66922C15.2126 4.56163 15.3492 4.5 15.4927 4.5H21.5C21.7762 4.5 22 4.72386 22 5V20.4094C22.0028 20.4784 21.991 20.5456 21.9671 20.6076ZM6.66906 19.9286H20.7983L18.3309 12.7857H4.20171L6.66906 19.9286Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocFolder);
export default __webpack_public_path__ + "static/media/doc-folder.1add8a6b8f8f319c0bb34270cece3394.svg";
export { ForwardRef as ReactComponent };